import React from 'react'
import PropTypes from "prop-types"
import { Modal, FormControl } from 'react-bootstrap'
import removeDiacritics from "Lib/diacritics"

import { getText } from '../lib/text.js'
import Button from '../components/Button.jsx'

/**
 * clean up the string and take the first 3 words
 */

function deleteSpaces(s) {
  return s.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '')
}

function reduceString(s) {
  const arr = deleteSpaces(s).split(" ", 3)
  let result = ""
  // eslint-disable-next-line no-return-assign
  arr.map(p => (
    result += `${p} `
  ))
  return result.substring(0, result.length - 1)
}

/**
 * 
 */

class DeleteConfirm extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      deleteValue: '',
      disabledButton: true,
      cleanName: this.cleanName()
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  
  cleanName() {
    const aName = this.props.activityName
    return removeDiacritics(reduceString(aName.toLowerCase()))
  }

  handleChange(event) {
    this.setState({ deleteValue: event.target.value.toLocaleLowerCase() }) 
  }

  handleSubmit() {
    this.props.onConfirm()
  }
  
  componentDidUpdate(_prevState, prevProps) {
    if (prevProps.activityName != this.props.activityName) {
      this.setState({ cleanName: this.cleanName() })
    }
  }

  render() {
    return (
      <Modal show onHide={this.props.onCancel}>
        <Modal.Header>
          <Modal.Title>
            Confirmación
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Escribe: <code>{this.state.cleanName}</code> para confirmar que quieres eliminarlo.</p>
          <FormControl 
            style={{ maxWidth: 400 }} 
            type="text" 
            value={this.state.deleteValue} 
            onChange={this.handleChange} 
          />
        </Modal.Body> 
        <Modal.Footer>
          <Button 
            disabled={this.state.deleteValue != this.state.cleanName} 
            bsStyle="danger" 
            onClick={this.handleSubmit}
            glyph="ok"
          >
            Eliminar
          </Button>          
          <Button onClick={ this.props.onCancel }> 
            {getText("Cancelar")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

DeleteConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  activityName: PropTypes.string.isRequired
}

export default DeleteConfirm